module.exports = __webpack_public_path__ + "static/media/clement.9567f780.webp";